import React from 'react'
import style from './style.css'

export default class Spinner extends React.Component
{
    render()
    {
        return (
            <div className={style.skfadingcircle}>
                  <div className={style.skcircle1 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle2 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle3 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle4 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle5 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle6 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle7 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle8 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle9 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle10 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle11 + ' ' + style.skcircle}></div>
                  <div className={style.skcircle12 + ' ' + style.skcircle}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/component/Spinner/FadingCircle/index.js